import { version as appPackageVersion } from "../../../../package.json";

export const PLATFORM_SIDEBAR_COLLAPSED_KEY =
  "control_tower_platform_sidebar_collapsed";

export const PLATFORM_VERSION = appPackageVersion.startsWith("v")
  ? appPackageVersion
  : `v${appPackageVersion}`;

export const APP_BAR_HEIGHT = 50;
export const SIDEBAR_LOGO_HEIGHT = 18;
export const SIDEBAR_COLLAPSED_INSET = 12;
export const SIDEBAR_COLLAPSED_HOVER_MARKER_WIDTH = 5;
export const SIDEBAR_COLLAPSED_HOVER_MARKER_HEIGHT = 26;
export const SIDEBAR_COLLAPSED_ITEM_SIZE = 32;
export const SIDEBAR_COLLAPSED_LOGO_HEIGHT = SIDEBAR_COLLAPSED_ITEM_SIZE;
export const SIDEBAR_TOGGLE_SIZE = 28;
export const SIDEBAR_COLLAPSE_ICON_EXPANDED = 22;
export const SIDEBAR_COLLAPSED_LOGO_RADIUS = 6;
export const SIDEBAR_WIDTH_EXPANDED = 304;
export const SIDEBAR_WIDTH_COLLAPSED =
  SIDEBAR_COLLAPSED_ITEM_SIZE + 2 * SIDEBAR_COLLAPSED_INSET;
export const SIDEBAR_PADDING_X = 6;
export const SIDEBAR_NAV_PADDING_X = 16;
export const SIDEBAR_NAV_PADDING_Y = 8;
export const SIDEBAR_NAV_ITEM_MARGIN_X = 8;
export const SIDEBAR_NAV_ICON_GAP = 11;
export const SIDEBAR_TRANSITION = "180ms ease";

export const SIDEBAR_COLOR_BG = "#f7f6f2";
export const SIDEBAR_COLOR_BORDER = "#e5e3dc";
export const SIDEBAR_COLOR_ACTIVE = "#ebe9e2";
export const SIDEBAR_COLOR_HOVER = "#efede6";
export const SIDEBAR_COLOR_TEXT = "#181714";
export const SIDEBAR_COLOR_TEXT_MUTED = "#444444";
export const SIDEBAR_COLOR_ICON = "#6a6960";
export const SIDEBAR_COLOR_GROUP_LABEL = "#a09e96";
export const SIDEBAR_FOOTER_PADDING_Y = 6;
export const SIDEBAR_FOOTER_PADDING_X = 14;
export const SIDEBAR_FOOTER_GAP = 10;
export const SIDEBAR_FOOTER_FONT_SIZE = 12;
export const SIDEBAR_AVATAR_SIZE = 30;
export const SIDEBAR_AVATAR_BG = "#e2dfd8";
export const SIDEBAR_AVATAR_COLOR = "#5f5e5a";
export const SIDEBAR_AVATAR_FONT_SIZE = 11;
export const SIDEBAR_FOOTER_SUBTITLE_FONT_SIZE = 10;

export const VISIBLE_FOR = {
  ALL: "all",
  INTERNAL: "internal"
};

export const PLATFORM_MODULE = {
  COLLABORATION: "collaboration",
  DISPOSITION: "disposition",
  TOURS: "tours",
  DOCUMENTS: "documents",
  MANAGEMENT: "management",
  DASHBOARD: "dashboard",
  INTERNAL_WENCO_TOURS: "internal-wenco-tours",
  SETTINGS: "settings"
};

export function getPlatformSidebarWidth(collapsed) {
  return collapsed ? SIDEBAR_WIDTH_COLLAPSED : SIDEBAR_WIDTH_EXPANDED;
}

export function readPlatformSidebarCollapsed() {
  try {
    return localStorage.getItem(PLATFORM_SIDEBAR_COLLAPSED_KEY) === "true";
  } catch (error) {
    return false;
  }
}

export function writePlatformSidebarCollapsed(collapsed) {
  try {
    localStorage.setItem(PLATFORM_SIDEBAR_COLLAPSED_KEY, String(collapsed));
  } catch (error) {
    // ignore storage errors
  }
}
